module.exports = __webpack_public_path__ + "static/media/rojo.49fc0c28.png";